import React from 'react';
import { movdTokens } from './movdTokens.js';

// Shared dark gradient hero used at the top of marketing/content pages so
// About/Contact/FAQ/Services/etc. share one header language instead of each
// page inventing its own gradient and typography scale.
export default function MovdMarketingHero({ eyebrow, title, subtitle, compact = false }) {
  return (
    <div style={{ background: `linear-gradient(135deg, ${movdTokens.color.action.primary} 0%, ${movdTokens.color.brand.inkMuted} 50%, ${movdTokens.color.brand.ink} 100%)`, color: '#fff', padding: compact ? 'clamp(32px, 6vw, 48px) 20px' : 'clamp(48px, 8vw, 80px) 20px', textAlign: 'center' }}>
      <div style={{ maxWidth: 640, margin: '0 auto' }}>
        {eyebrow && <p style={{ margin: 0, color: 'rgba(255,255,255,.6)', letterSpacing: '.3em', fontSize: 12, fontWeight: 700, textTransform: 'uppercase' }}>{eyebrow}</p>}
        <h1 style={{ margin: '8px 0 16px', fontWeight: 900, fontSize: 'clamp(2rem, 6vw, 3rem)', lineHeight: 1.1 }}>{title}</h1>
        {subtitle && <p style={{ margin: 0, color: 'rgba(255,255,255,.8)', fontSize: 'clamp(1rem, 2vw, 1.15rem)' }}>{subtitle}</p>}
      </div>
    </div>
  );
}
